import Box from '@mui/material/Box';
import useFornecedorCadastro from '../../../../hooks/useFornecedorCadastro';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { HeaderFormActions } from '../../../../shared/components/HeaderFormActions';
import { Loader } from '../../../../shared/components/Loader';
import Typography from '@mui/material/Typography';
import { Input } from '../../../../shared/components/Input';
import { InputCNPJCPF } from '../../../../shared/components/InputCNPJ';
import { InputDate } from '../../../../shared/components/InputDate';
import { InputCEP } from '../../../../shared/components/InputCEP';
import { InputTelephone } from '../../../../shared/components/InputTelephone';
import { InputPhone } from '../../../../shared/components/InputPhone';
import { useParams } from 'react-router-dom';

export default function FornecedorCadastrar() {
  const { id } = useParams();
  const fornecedorId = id ? parseInt(id, 10) : null;

  const {values, errors, touched, handleSubmit, handleBlur, handleChange, loading, backActions, handleZipCode} = useFornecedorCadastro(fornecedorId)

  return (
    <Loader loading={loading}>
      <HeaderComponent text={'CADASTRO DE FORNECEDOR'} />
      <Box className='p-3'>
        <form autoComplete='off' onSubmit={handleSubmit} name='customer-detail'>
          <Box className='grid grid-cols-8 gap-7 pt-4'>
            <Box className='col-span-3'>
              <HeaderFormActions backActions={() => backActions()} />
            </Box>
            <Typography className='col-span-8' variant='h6'>
              Dados Fornecedor
            </Typography>
            <Input
              label='Nome'
              className='col-span-4'
              name='Nome'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Nome && errors.Nome ? errors.Nome : ''}
              hasError={!!(touched.Nome && errors.Nome)}
              value={values.Nome}
            />
            <InputCNPJCPF
              label='CPF / CNPJ'
              className='col-span-2'
              name='CpfCnpj'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.CpfCnpj && errors.CpfCnpj ? errors.CpfCnpj : ''}
              hasError={!!(touched.CpfCnpj && errors.CpfCnpj)}
              value={values.CpfCnpj}
            />
            <Input
              label='RG / Inscrição Estadual'
              className='col-span-2'
              name='RgIe'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.RgIe && errors.RgIe ? errors.RgIe : ''}
              hasError={!!(touched.RgIe && errors.RgIe)}
              value={values.RgIe}
            />
            <InputDate
              label='Data de Nascimento'
              className='col-span-2'
              name='DataNascimento'
              handleBlur={handleBlur}
              handleChange={handleChange}
              hasError={!!(touched.DataNascimento && errors.DataNascimento)}
              value={values.DataNascimento}
            />
            <Input
              label='Razão Social'
              className='col-span-4'
              name='RazaoSocial'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={
                touched.RazaoSocial && errors.RazaoSocial
                  ? errors.RazaoSocial
                  : ''
              }
              hasError={!!(touched.RazaoSocial && errors.RazaoSocial)}
              value={values.RazaoSocial}
            />
            <Input
              label='Nacionalidade'
              className='col-span-2'
              name='Nacionalidade'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={
                touched.Nacionalidade && errors.Nacionalidade
                  ? errors.Nacionalidade
                  : ''
              }
              hasError={!!(touched.Nacionalidade && errors.Nacionalidade)}
              value={values.Nacionalidade}
            />
            <Typography className='col-span-8' variant='h6'>
              Dados Endereço
            </Typography>
            <InputCEP
              label='CEP'
              className='col-span-2'
              name='Cep'
              handleBlur={handleBlur}
              handleChange={handleZipCode}
              error={touched.Cep && errors.Cep ? errors.Cep : ''}
              hasError={!!(touched.Cep && errors.Cep)}
              value={values.Cep}
            />
            <Box className='col-span-6' />
            <Input
              label='Estado'
              className='col-span-1'
              name='Estado'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Estado && errors.Estado ? errors.Estado : ''}
              hasError={!!(touched.Estado && errors.Estado)}
              value={values.Estado}
            />
            <Input
              label='Cidade'
              className='col-span-3'
              name='Cidade'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Cidade && errors.Cidade ? errors.Cidade : ''}
              hasError={!!(touched.Cidade && errors.Cidade)}
              value={values.Cidade}
            />
            <Input
              label='Bairro'
              className='col-span-4'
              name='Bairro'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Bairro && errors.Bairro ? errors.Bairro : ''}
              hasError={!!(touched.Bairro && errors.Bairro)}
              value={values.Bairro}
            />
            <Input
              label='Endereço'
              className='col-span-4'
              name='Endereco'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Endereco && errors.Endereco ? errors.Endereco : ''}
              hasError={!!(touched.Endereco && errors.Endereco)}
              value={values.Endereco}
            />
            <Input
              label='Numero'
              className='col-span-2'
              name='Numero'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Numero && errors.Numero ? errors.Numero : ''}
              hasError={!!(touched.Numero && errors.Numero)}
              value={values.Numero}
            />
            <Input
              label='Complemento'
              className='col-span-2'
              name='Complemento'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={
                touched.Complemento && errors.Complemento
                  ? errors.Complemento
                  : ''
              }
              hasError={!!(touched.Complemento && errors.Complemento)}
              value={values.Complemento}
            />
            <Typography className='col-span-8' variant='h6'>
              Dados de Contato
            </Typography>
            <InputTelephone
              label='Telefone'
              className='col-span-2'
              name='Telefone'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Telefone && errors.Telefone ? errors.Telefone : ''}
              hasError={!!(touched.Telefone && errors.Telefone)}
              value={values.Telefone}
            />
            <InputPhone
              label='Celular'
              className='col-span-2'
              name='Celular'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Celular && errors.Celular ? errors.Celular : ''}
              hasError={!!(touched.Celular && errors.Celular)}
              value={values.Celular}
            />
            <Input
              label='Email'
              className='col-span-2'
              name='Email'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Email && errors.Email ? errors.Email : ''}
              hasError={!!(touched.Email && errors.Email)}
              value={values.Email}
            />
            <Input
              label='Site'
              className='col-span-4'
              name='Site'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Site && errors.Site ? errors.Site : ''}
              hasError={!!(touched.Site && errors.Site)}
              value={values.Site}
            />
          </Box>
        </form>
      </Box>
    </Loader>
  );
}
